export const FETCH_USER_EDUCATION_REQUEST = 'FETCH_USER_EDUCATION_REQUEST'
export const FETCH_USER_EDUCATION_SUCCESS = 'FETCH_USER_EDUCATION_SUCCESS'
export const FETCH_USER_EDUCATION_FAILED = 'FETCH_USER_EDUCATION_FAILED'
